<template lang="html">
    <div class="page" id="singleLesson">
        <header class="pageHeader rounded darken">
            <fade-image class="darken" src="assets/headers/lessons.png" />
        </header>

        <div class="scroller2">
            <header>
                <h2>
                    {{ start }} <span v-if="isRange">to {{ end }}</span>
                </h2>
                <ul class="links">
                    <li>
                        <a class="cancel" @click.prevent="$router.back()" href="#">
                            <x-icon class="icon" />
                        </a>
                    </li>
                </ul>
            </header>

            <span class="info player small" v-if="lessonBookingOpen">Bookings</span>

            <ul class="lessonList" id="proLessonList">
                <li v-for="lesson in bookings" :key="lesson.id">
                    <router-link :to="{ name: 'proLessonChange', params: { id: lesson.id } }">
                        <span class="time">
                            <template v-if="lesson.start != lesson.end">
                                {{ $date("2020-12-08 " + lesson.start).format("HH:mm") }} -
                                {{ $date("2020-12-08 " + lesson.end).format("HH:mm") }}
                            </template>
                        </span>

                        <span class="name">
                            <template v-if="lesson.guest_name">{{ lesson.guest_name }}</template>
                            <template v-else-if="lesson.player"
                                >{{ initial(lesson.player.first_name) }}
                                {{ lesson.player.last_name }}</template
                            >
                        </span>

                        <chevron-right-icon class="icon" />
                    </router-link>
                </li>
            </ul>
            <span
                v-if="bookings && bookings.length == 0 && lessonBookingOpen"
                class="info white"
                style="font-size: 16px"
                >No bookings</span
            >

            <router-link
                v-if="lessonBookingOpen"
                class="button dark mb"
                :to="{ name: 'proLessonBook' }"
            >
                Book a lesson
                <chevron-right-icon class="icon" />
            </router-link>

            <availability-list
                @onAvailability="availabilityAdded"
                @availabilityRemoved="getBookings"
            />
        </div>
    </div>
</template>

<script>
import { XIcon } from "vue-feather-icons";
import FadeImage from "@/components/App/fade-image";
import AvailabilityList from "@/components/Pro/Lessons/availability-list";
import { ChevronRightIcon } from "vue-feather-icons";
export default {
    name: "lesson",
    components: { XIcon, FadeImage, AvailabilityList, ChevronRightIcon },
    created() {
        this.getBookings();
    },
    data() {
        return {
            bookings: false,
            lessonBookingOpen: false,
        };
    },
    computed: {
        start() {
            return this.$date(this.$route.params.start.replace(/-/g, "/"), "YYYY-mm-dd").format(
                "D MMM YYYY",
            );
        },
        end() {
            return this.$date(this.$route.params.end.replace(/-/g, "/"), "YYYY-mm-dd").format(
                "D MMM YYYY",
            );
        },
        isRange() {
            return this.start !== this.end;
        },
    },
    methods: {
        initial(name) {
            if (!name) {
                return "";
            }

            return name.charAt(0) + ".";
        },
        availabilityAdded(availaibity_count) {
            if (availaibity_count > 0) {
                this.lessonBookingOpen = true;
            } else {
                this.lessonBookingOpen = false;
            }
        },
        getBookings() {
            window.axios
                .get("booking?start=" + this.start + "&end=" + this.end)
                .then((response) => {
                    this.bookings = response.data;
                });
        },
    },
};
</script>

<style lang="scss" scoped>
#proLessonList {
    li {
        a {
            background: white;
            height: 47px;
            border-radius: 12px;
            padding: 20px;
            color: $green_0;
            margin-bottom: 10px;
            padding-top: 16px;
            padding-bottom: 16px;
            display: block;
            text-decoration: none;
            padding-left: 150px;
            position: relative;
            .time {
                position: absolute;
                left: 20px;
            }

            .icon {
                position: absolute;
                right: 20px;
                top: 12px;
            }
        }
    }
}
</style>
